<div
  class="autocomplete-results"
  [class.no-shadow]="noShadow()"
  [class.no-fixed]="noFixed()"
  [class.small]="small()"
  #resultsEl
  data-test-id="autocomplete-results"
>
  @for (item of results(); track $index) {
    <div (pointerdown)="select(item, $event)" class="result" [class.selected]="autoSelectIndex() === $index">
      <app-avatar [user]="item"></app-avatar>
      <div class="user-data">
        <div class="name">
          {{ item.first_name }}
          @if (item.last_name) {
            {{ item.last_name }}
          }
        </div>
        <div class="email">{{ item.email }}</div>
      </div>
    </div>
  }
  <!-- <div (pointerdown)="loadContactsFromGoogle($event)">Load contacts from google</div> -->
</div>
